import React from 'react'
export default function SC_CheckBox({checked,onChange=null}) {
  return <div 
      onClick={onChange && (()=>{
          onChange(!checked)
      })}
      css={`
      border:1px solid rgba(76,76,76,0.81);
      cursor:pointer;
      border-radius:3px;
      padding: 0px 2px;
      font-size: 12px;
      font-weight:bolder;
      color: blue;
      `}><div css={`
        visibility:${checked ? 'visible' : 'hidden'};
      `}>✔
        </div>
      </div>
}